export default "__VITE_ASSET__CRX0mgNZ__"